import { footerBackgroundColor, footerFontColor } from 'globals/colors';
import { poweredByIcon } from 'globals/assets';
import { zIndexAboveContent, footerHeightPercentage } from 'globals/styles';

const styles = {
  wrapper: {
    width: '100%',
    height: `${footerHeightPercentage}%`,
    lineHeight: '16px',
    fontSize: 11,
    fontWeight: 500,
    backgroundColor: footerBackgroundColor,
    color: footerFontColor,
    textTransform: 'uppercase',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: zIndexAboveContent,
  },
  link: {
    color: footerFontColor,
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    backgroundImage: `url("${poweredByIcon}")`,
    backgroundSize: 14,
    backgroundRepeat: 'no-repeat',
    height: 15,
    width: 15,
    color: footerFontColor,
    display: 'inline-block',
  },
};

export default styles;
